import { useQuery } from "@apollo/client";
import { useLocation } from "react-router";

import DocumentationIconButton from "components/DocumentationIconButton";
import FeedbackButton from "components/FeedbackButton";
import DesktopView from "components/Mobile/DesktopView";
import ViewHeader from "components/ViewHeader";
import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Tab from "ds/components/Tab";
import useTypedFlags from "hooks/useTypedFlags";
import { getDocsUrl } from "utils/getDocsUrl";

import { GET_ACCOUNT_STACKS } from "../gql";

const ResourcesHeader = () => {
  const { pathname } = useLocation();
  const { unmanagedResourcesUi } = useTypedFlags();

  const { data } = useQuery<{ hasAnsibleStacks?: boolean }>(GET_ACCOUNT_STACKS);

  const configurationManagementEnabled = !!data?.hasAnsibleStacks;
  const showResourcesNavigation = configurationManagementEnabled || unmanagedResourcesUi;

  return (
    <ViewHeader>
      <ViewHeaderTitle>Resources</ViewHeaderTitle>
      <DesktopView>
        <ViewHeaderWrapper direction="row" align="center">
          {configurationManagementEnabled &&
            pathname === "/resources/configuration-management" && (
              <FeedbackButton id="config-management-in-resources-feedback" />
            )}
          {pathname === "/resources/iac-management" && (
            <FeedbackButton id="iac-management-in-resources-feedback" />
          )}
          <DocumentationIconButton
            href={getDocsUrl("/concepts/resources#account-level-resources")}
            tooltipText="Go to account-level resources documentation"
          />
        </ViewHeaderWrapper>
      </DesktopView>

      {showResourcesNavigation && (
        <ViewHeaderNavigation>
          <Tab id="iac" to="/resources/iac-management" label="IaC management" />

          {configurationManagementEnabled && (
            <Tab
              id="config-mgmt"
              data-userflow-id="resources-configuration-management"
              to="/resources/configuration-management"
              label="Configuration management"
            />
          )}

          {unmanagedResourcesUi && (
            <Tab id="scans" to="/resources/scans" label="Cloud scanning" />
          )}
        </ViewHeaderNavigation>
      )}
    </ViewHeader>
  );
};

export default ResourcesHeader;
